import React, {useState} from 'react';
import './style.css';


const Throbber = () => {
    return (
        <div class="throbber"></div>
    );
};

export { Throbber };